import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAdminAuth } from '@/auth/use-admin-auth';

export default function NotAdminPage() {
  const { account, logout } = useAdminAuth();
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md border-destructive/40">
        <CardHeader>
          <CardTitle className="text-destructive">Not an admin account</CardTitle>
          <CardDescription>
            Wallet <code className="font-mono break-all">{account}</code> is not on the admin
            allowlist.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button variant="secondary" onClick={() => logout()} className="w-full">
            Sign out
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
